import React from "react";
import "./Body.css";
import selfPotrait from "./introimg.jpg";
import OIC from "./images/OIC.png";

import IMAGES from "./images/index";

export default function Body() {
  return (
    <div className="container">
      <section className="grid gridTwoColumns">
        <div>
          <img src={selfPotrait} alt="" className="introImage rounded" />
        </div>
        <div className="introParagraph">
          <h2>About Me</h2>
          <p>
            Hello, I am happy you're here. Firstly, welcome. It's my pleasure to
            give you a glimpse of what we could achieve together. I am a senior
            clinician by background. To diversify the way I enrich lifestyles
            and the health of others, I have immersed myself in software
            engineering, developing cutting edge software that will scale as
            your business needs grow. I am keen to delve into an extraordinary
            opportunity to bring your dream solutions to life. With a unique
            knowledge base, I am confident that I can deliver exceptional
            results.
          </p>
          <p>
            I am an expressive singinger 🎤, avid traveller 🛫, food lover 🥙🥘,
            and much more. Everyday is a chance to do amazing things.
          </p>
          {/* <p>
            I am currently in the design stage of my application for a handy
            blog for those at home needing a little extra help.
          </p> */}
          <p>
            I am currently based in <strong>Manchester, UK </strong>
          </p>
          <a
            href="https://www.dropbox.com/scl/fi/28mln61lrrk5zh8xscya7/CV-25.pdf?rlkey=e1q01bgelhm8ewfp5cdofrrfw&st=5d6ehnj7&dl=0"
            target="_blank"
            rel="noreferrer"
            className=" resume btn btn-secondary btn-lg btn-block "
            type="button"
          >
            My Resume
          </a>
        </div>
      </section>

      <section className="projectDisplay">
        <div className="OICSection">
          <h2 className="mb-5">Orbis Integra Consultancy Web Solution</h2>
          <section className="grid gridTwoColumns">
            <div>
              <a href="https://orbint.uk//" target="_blank" rel="noreferrer">
                <img className="projectImages" src={OIC} alt="OICImage" />
              </a>
            </div>
            <h4 className="mt-2">
              For Orbis Integra Consultancy, I designed and developed a clean,
              responsive web solution focused on healthcare innovation. The
              project included creating a complete wireframe and UI layout,
              implementing a Bootstrap 5 front end with modern, minimalistic
              styling, and integrating interactive elements such as a
              Netlify-handled contact form with spam protection and client-side
              validation.
              <br />
              <br />I also configured custom domain deployment on Netlify,
              optimized mobile responsiveness, and ensured scalable code
              structure for future feature growth — delivering a polished,
              production-ready static website that reflects Orbis Integra's
              professional brand identity.
            </h4>
          </section>
        </div>

        {/* <div className="weatherAppSection">
          <h2 className="mb-5">Project Weather App</h2>

          <section className="grid gridTwoColumns">
            <a
              href="https://nyashaweatherapp-js.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="projectImages"
                src={IMAGES.WeatherAppTwo}
                alt="weatherProjectImage"
              />
            </a>

            <h4 className="mt-5">
              I have developed a sleek and user-friendly weather application
              using JavaScript that provides real-time weather information at
              your fingertips. The application boasts a clean and intuitive
              interface, making it easy for users to access the latest weather
              data for their desired locations.
              <br />
              Staying informed about the weather has never been more convenient
              and visually appealing. Users can simply input a city or location
              name, and the application retrieves up-to-date weather conditions,
              including temperature, humidity, wind speed, and a detailed
              forecast. It also features visually appealing icons and graphics
              to represent weather conditions, enhancing the user experience.{" "}
            </h4>
          </section>
        </div>

        <div className="dictionaryAppSection">
          <h2 className="mb-5">Project React Dictionary</h2>
          <section className="grid gridTwoColumns">
            <h4 className="mt-5">
              I've developed an innovative dictionary application built with
              React that delivers a seamless and dynamic language reference
              experience. This app combines the power of a dictionary with the
              flexibility of a modern web application.
              <br /> This dictionary app is a valuable resource for students,
              writers, and language enthusiasts, providing an efficient and
              engaging way to explore and expand one's vocabulary.
            </h4>
            <a
              href="https://nys-pink-dictionary.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="projectImages"
                src={IMAGES.PinkDictionaryOne}
                alt="dictionaryProjectImage"
              />
            </a>
          </section>
        </div> */}

        <div className="philosophyBlogSection">
          <h2 className="mb-5">Project Philosophy Blog</h2>{" "}
          <section className="grid gridTwoColumns">
            <a
              href="https://oneroadtofreedom.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="projectImages"
                src={IMAGES.OneRoadFive}
                alt="oneRoadToFreedomImage"
              />
            </a>
            <h4 className="mt-5">
              I've meticulously crafted a thought-provoking philosophy blog that
              showcases the power of advanced CSS and HTML, incorporating
              dynamic grid layouts to present philosophical insights in a
              visually engaging manner. <br />
              Utilizing advanced CSS techniques, the layout is responsive,
              making it accessible and visually appealing across various
              devices. I've seamlessly integrated embedded content, enriching
              the blog with multimedia elements.
            </h4>
          </section>
        </div>

        <div className="travelBlogSection">
          <h2 className="mb-5">Project Responsive Travel Blog</h2>
          <section className="grid gridTwoColumns">
            <h4 className="mt-5">
              I've designed a captivating travel guide using responsive HTML and
              CSS, offering a visually appealing and informative resource for
              globetrotters and adventure seekers. This travel guide seamlessly
              adapts to various screen sizes, making it accessible on both
              desktops and mobile devices.{" "}
            </h4>
            <a
              href="https://nyasha-swissadventure.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="projectImages"
                src={IMAGES.TravelBlogOne}
                alt="travelBlogImage"
              />
            </a>{" "}
          </section>
        </div>
      </section>
    </div>
  );
}
